import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as content from '../../../../content'

/**
 * Displays tenant general information and permitted tenant edit action.
 */
@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.value.Component,
    content.admin.modals.tenant.Component,
  ],
  selector: 'atn-admin-tenant-page-general-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.tenants.Collection} */
  public readonly tenantsEc = ngCore.inject(state.admin.tenants.Collection)

  /** @see {@link state.admin.contexts.Feature} */
  private readonly _contextsFeature = ngCore.inject(
    state.admin.contexts.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Currently selected tenant */
  private readonly _tenantSg = ngCore.computed(() =>
    this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
      .getEntity()
      .asSignal(),
  )

  /** Currently selected tenant name */
  public readonly nameSg = ngCore.computed(
    (tenant = this._tenantSg()) => tenant?.name,
  )

  /** Currently selected tenant code */
  public readonly codeSg = ngCore.computed(
    (tenant = this._tenantSg()) => tenant?.code,
  )

  /** Currently selected tenant alias */
  public readonly aliasSg = ngCore.computed(
    (tenant = this._tenantSg()) => tenant?.alias,
  )

  /** Currently selected tenant theme color */
  public readonly colorSg = ngCore.computed(
    (tenant = this._tenantSg()) => tenant?.color ?? ds.color.Scale.PRIMARY.main,
  )

  /** Whether the current admin user can edit selected tenant information */
  public readonly canEditTenantSg = ngCore.computed(() =>
    state.admin.portalAccess.ContentActionAccess.canEditTenant({
      context: this._contextsFeature.selectors.tenantContext.asSignal(),
      user: this._meFeature.selectors.currentUser.asSignal(),
    }),
  )

  /** Put selected tenant in editing state */
  public editClickHandler(): void {
    this.tenantsEc.plugins.editingPlugin.feature.actions.edit
      .from('AdminTenant.GeneralTab.Edit.Icon.Clicked')
      .dispatch({
        id: this._tenantSg()?.id,
      })
  }
}
